export const ENDPOINTS = {
  packages: () => `/billing/package`
};
